export function formatStudioDisplayName(
  licenseNumber: string | undefined,
  name: string
) {
  return licenseNumber ? `${licenseNumber} - ${name}` : name
}
